






















import { Vue, Prop, Component } from 'vue-property-decorator'
import Chart from '@/components/Chart/index.vue'
@Component({
  name: 'MainTitle',
  components: { Chart }
})
export default class extends Vue {
  @Prop({ default: '#00B66C' }) private color!: string
  private chartId: string = ''
  @Prop() private normData!: any
  @Prop() private data!: any
  @Prop() private xNames!: any

  private option: any = {
    animation: false,
    grid: {
      bottom: 90,
      top: 40,
      right: 10
    },
    title: {
      subtext: '占比（%）'
    },
    // legend: {
    //   data: ['参考标准', '当前占比'],
    //   icon: 'circle',
    //   right: 0,
    //   top: 10,
    //   itemWidth: 6
    // },
    xAxis: [{
      type: 'category',
      data: ['很差', '较差', '一般', '良好', '优秀'],
      splitLine: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        interval: 0
      }
    }],
    yAxis: [{
      type: 'value',
      splitLine: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      }
    }],
    series: [{
      name: '参考标准',
      type: 'bar',
      data: [],
      itemStyle: {
        borderWidth: 1,
        borderColor: '#666',
        borderType: 'dotted',
        // color: 'transparent',
        color: '#FFFFFF'
      },
      barWidth: 15

    },
    {
      name: '当前占比',
      type: 'bar',
      barGap: '-80%',
      data: [],
      label: {
        show: true,
        position: 'top',
        formatter: '{c}%'
      },
      itemStyle: {
        color: this.color
      },
      barWidth: 9
    }
    ]
  }
  created() {
    this.chartId = new Date().getTime() + '_' + parseInt(Math.random() * 10000000 + '')
    this.option.xAxis[0].data = this.xNames
    this.option.series[0].data = this.normData
    this.option.series[1].data = this.data
  }
}
